export default __webpack_public_path__ + "static/media/gallery-wip-3d-model_01.480d4ab4.jpg";